import React, {
    useState
} from 'react';


import {
    useDispatch,
    useSelector
} from 'react-redux';


import {

    actualizarActividadesAction,
    actualizarInfoActividadesAction

} from '../../actions/actividadesActions';


// css
import {

    ContenedorDisponibles,
    CategoriasActividades,
    BotonCategoriaActividad,

    LeyendaSeleccion,
    ItemLeyenda,
    PuntoLeyenda,

    NavegadorActividades,
    ColumnaNavegacion,
    TituloColumnaActividad,

    BotonNivelActividad,

    FilaEjercicio,
    MiniaturaEjercicio,
    NombreEjercicio,
    IndicadorSeleccion,

    SinContenidoActividad

} from '../Css/StyledActividadesDomicilio';



const SeleccionarActividadesDisponibles = () => {


    const dispatch =
        useDispatch();


    const infoActividades =
        useSelector(
            (state) =>
                state.informacion.info_actividades
        );


    const {

        uno,
        dos,
        tres,
        cuatro,
        cinco,
        actividades

    } = infoActividades;


    const seleccionadas =
        useSelector(
            (state) =>
                state.actividades.seleccionadas
        );


    const [
        unoId,
        setUnoId
    ] = useState(
        1
    );


    const [
        dosId,
        setDosId
    ] = useState(
        ''
    );


    const [
        tresId,
        setTresId
    ] = useState(
        ''
    );


    const [
        cuatroId,
        setCuatroId
    ] = useState(
        ''
    );


    const [
        cincoId,
        setCincoId
    ] = useState(
        ''
    );



    /*
    ====================================
    SELECCIONAR / DESELECCIONAR
    ====================================
    */

    const seleccionoEjercicio = (
        e,
        id,
        columna,
        tengoColor
    ) => {


        e.preventDefault();


        const actualizoInfoActividades =
            JSON.parse(
                JSON.stringify(
                    infoActividades
                )
            );


        const actividadSeleccionada =
            JSON.parse(
                JSON.stringify(
                    seleccionadas
                )
            );


        let iActividades =
            actualizoInfoActividades.actividades.findIndex(
                item => {

                    return item.id === id;

                }
            );


        if (
            actualizoInfoActividades
                .actividades[
                    iActividades
                ]
                .seleccionado
        ) {

            actualizoInfoActividades
                .actividades[
                    iActividades
                ]
                .seleccionado =
                    false;

        } else {

            actualizoInfoActividades
                .actividades[
                    iActividades
                ]
                .seleccionado =
                    true;


            actualizoInfoActividades
                .actividades[
                    iActividades
                ]
                .contador =
                    1;

        }


        let estadoColor =
            tengoColor
                ? false
                : true;


        if (
            tengoColor
        ) {

            let index =
                actividadSeleccionada.indexOf(
                    id
                );


            actividadSeleccionada.splice(
                index,
                1
            );

        } else {

            actividadSeleccionada.push(
                id
            );

        }


        if (
            columna ===
            'uno'
        ) {

            let i =
                actualizoInfoActividades.uno.findIndex(
                    item => {

                        return item.id === id;

                    }
                );


            actualizoInfoActividades
                .uno[i]
                .color =
                    estadoColor;

        } else if (
            columna ===
            'dos'
        ) {

            let i =
                actualizoInfoActividades.dos.findIndex(
                    item => {

                        return item.id === id;

                    }
                );


            actualizoInfoActividades
                .dos[i]
                .color =
                    estadoColor;

        } else if (
            columna ===
            'tres'
        ) {

            let i =
                actualizoInfoActividades.tres.findIndex(
                    item => {

                        return item.id === id;

                    }
                );


            actualizoInfoActividades
                .tres[i]
                .color =
                    estadoColor;

        } else if (
            columna ===
            'cuatro'
        ) {

            let i =
                actualizoInfoActividades.cuatro.findIndex(
                    item => {

                        return item.id === id;

                    }
                );


            actualizoInfoActividades
                .cuatro[i]
                .color =
                    estadoColor;

        } else if (
            columna ===
            'cinco'
        ) {

            let i =
                actualizoInfoActividades.cinco.findIndex(
                    item => {

                        return item.id === id;

                    }
                );


            actualizoInfoActividades
                .cinco[i]
                .color =
                    estadoColor;

        }


        dispatch(
            actualizarActividadesAction(
                actividadSeleccionada
            )
        );


        dispatch(
            actualizarInfoActividadesAction(
                actualizoInfoActividades
            )
        );

    };



    return (

        <ContenedorDisponibles>


            {/*
            ====================================
            CATEGORÍAS PRINCIPALES
            ====================================
            */}


            <CategoriasActividades>


                {
                    !uno
                        ?
                        null
                        :
                        uno.map(
                            item => (


                                item.ultimo ===
                                'uno'
                                    ?

                                    <FilaEjercicio

                                        key={
                                            item.id
                                        }

                                    >


                                        <NombreEjercicio>

                                            {
                                                item.nombre_mostrar
                                            }

                                        </NombreEjercicio>


                                        <IndicadorSeleccion

                                            type="button"

                                            seleccionado={
                                                item.color
                                            }

                                            onClick={
                                                (e) =>
                                                    seleccionoEjercicio(
                                                        e,
                                                        item.id,
                                                        "uno",
                                                        item.color
                                                    )
                                            }

                                        />


                                    </FilaEjercicio>


                                    :

                                    <BotonCategoriaActividad

                                        key={
                                            item.id_uno
                                        }

                                        type="button"

                                        activo={
                                            unoId ===
                                            item.id_uno
                                        }

                                        onClick={
                                            () => {

                                                setUnoId(
                                                    item.id_uno
                                                );

                                                setDosId(
                                                    ''
                                                );

                                                setTresId(
                                                    ''
                                                );

                                                setCuatroId(
                                                    ''
                                                );

                                                setCincoId(
                                                    ''
                                                );

                                            }
                                        }

                                    >

                                        {
                                            item.uno
                                        }

                                    </BotonCategoriaActividad>


                            )
                        )
                }


            </CategoriasActividades>


            {/*
            ====================================
            LEYENDA
            ====================================
            */}


            <LeyendaSeleccion>


                <ItemLeyenda>

                    <PuntoLeyenda
                        seleccionado={
                            true
                        }
                    />

                    Seleccionado

                </ItemLeyenda>


                <ItemLeyenda>

                    <PuntoLeyenda
                        seleccionado={
                            false
                        }
                    />

                    No seleccionado

                </ItemLeyenda>


            </LeyendaSeleccion>


            {/*
            ====================================
            NAVEGACIÓN
            ====================================
            */}


            <NavegadorActividades>


                {/*
                ====================================
                NIVEL DOS
                ====================================
                */}


                <ColumnaNavegacion>


                    <TituloColumnaActividad>

                        Categoría

                    </TituloColumnaActividad>


                    {
                        !dos
                            ?
                            null
                            :
                            dos

                                .filter(
                                    item =>
                                        item.id_uno ===
                                            unoId &&
                                        item.id_dos !==
                                            ''
                                )

                                .map(
                                    item => (


                                        item.ultimo ===
                                        'dos'
                                            ?

                                            <FilaEjercicio

                                                key={
                                                    item.id
                                                }

                                            >


                                                <MiniaturaEjercicio

                                                    src={
                                                        `/img/portadas/${
                                                            actividades.find(
                                                                ele =>
                                                                    item.id ===
                                                                    ele.id
                                                            ).portada
                                                        }.jpg`
                                                    }

                                                />


                                                <NombreEjercicio>

                                                    {
                                                        item.nombre_mostrar
                                                    }

                                                </NombreEjercicio>


                                                <IndicadorSeleccion

                                                    type="button"

                                                    seleccionado={
                                                        item.color
                                                    }

                                                    onClick={
                                                        (e) =>
                                                            seleccionoEjercicio(
                                                                e,
                                                                item.id,
                                                                "dos",
                                                                item.color
                                                            )
                                                    }

                                                />


                                            </FilaEjercicio>


                                            :

                                            <BotonNivelActividad

                                                key={
                                                    item.id_dos
                                                }

                                                type="button"

                                                activo={
                                                    dosId ===
                                                    item.id_dos
                                                }

                                                onClick={
                                                    () => {

                                                        setDosId(
                                                            item.id_dos
                                                        );

                                                        setTresId(
                                                            ''
                                                        );

                                                        setCuatroId(
                                                            ''
                                                        );

                                                        setCincoId(
                                                            ''
                                                        );

                                                    }
                                                }

                                            >

                                                {
                                                    item.dos
                                                }

                                            </BotonNivelActividad>


                                    )
                                )
                    }


                </ColumnaNavegacion>


                {/*
                ====================================
                NIVEL TRES
                ====================================
                */}


                <ColumnaNavegacion>


                    <TituloColumnaActividad>

                        Subcategoría

                    </TituloColumnaActividad>


                    {
                        !tres
                            ?
                            null
                            :
                            tres

                                .filter(
                                    item =>
                                        item.id_dos ===
                                            dosId &&
                                        item.id_tres !==
                                            ''
                                )

                                .map(
                                    item => (


                                        item.ultimo ===
                                        'tres'
                                            ?

                                            <FilaEjercicio

                                                key={
                                                    item.id
                                                }

                                            >


                                                <MiniaturaEjercicio

                                                    src={
                                                        `/img/portadas/${
                                                            actividades.find(
                                                                ele =>
                                                                    item.id ===
                                                                    ele.id
                                                            ).portada
                                                        }.jpg`
                                                    }

                                                />


                                                <NombreEjercicio>

                                                    {
                                                        item.nombre_mostrar
                                                    }

                                                </NombreEjercicio>


                                                <IndicadorSeleccion

                                                    type="button"

                                                    seleccionado={
                                                        item.color
                                                    }

                                                    onClick={
                                                        (e) =>
                                                            seleccionoEjercicio(
                                                                e,
                                                                item.id,
                                                                "tres",
                                                                item.color
                                                            )
                                                    }

                                                />


                                            </FilaEjercicio>


                                            :

                                            <BotonNivelActividad

                                                key={
                                                    item.id_tres
                                                }

                                                type="button"

                                                activo={
                                                    tresId ===
                                                    item.id_tres
                                                }

                                                onClick={
                                                    () => {

                                                        setTresId(
                                                            item.id_tres
                                                        );

                                                        setCuatroId(
                                                            ''
                                                        );

                                                        setCincoId(
                                                            ''
                                                        );

                                                    }
                                                }

                                            >

                                                {
                                                    item.tres
                                                }

                                            </BotonNivelActividad>


                                    )
                                )
                    }


                </ColumnaNavegacion>


                {/*
                ====================================
                NIVEL CUATRO
                ====================================
                */}


                <ColumnaNavegacion>


                    <TituloColumnaActividad>

                        Grupo

                    </TituloColumnaActividad>


                    {
                        !cuatro
                            ?
                            null
                            :
                            cuatro

                                .filter(
                                    item =>
                                        item.id_tres ===
                                            tresId &&
                                        item.id_cuatro !==
                                            ''
                                )

                                .map(
                                    item => (


                                        item.ultimo ===
                                        'cuatro'
                                            ?

                                            <FilaEjercicio

                                                key={
                                                    item.id
                                                }

                                            >


                                                <MiniaturaEjercicio

                                                    src={
                                                        `/img/portadas/${
                                                            actividades.find(
                                                                ele =>
                                                                    item.id ===
                                                                    ele.id
                                                            ).portada
                                                        }.jpg`
                                                    }

                                                />


                                                <NombreEjercicio>

                                                    {
                                                        item.nombre_mostrar
                                                    }

                                                </NombreEjercicio>


                                                <IndicadorSeleccion

                                                    type="button"

                                                    seleccionado={
                                                        item.color
                                                    }

                                                    onClick={
                                                        (e) =>
                                                            seleccionoEjercicio(
                                                                e,
                                                                item.id,
                                                                "cuatro",
                                                                item.color
                                                            )
                                                    }

                                                />


                                            </FilaEjercicio>


                                            :

                                            <BotonNivelActividad

                                                key={
                                                    item.id_cuatro
                                                }

                                                type="button"

                                                activo={
                                                    cuatroId ===
                                                    item.id_cuatro
                                                }

                                                onClick={
                                                    () => {

                                                        setCuatroId(
                                                            item.id_cuatro
                                                        );

                                                        setCincoId(
                                                            ''
                                                        );

                                                    }
                                                }

                                            >

                                                {
                                                    item.cuatro
                                                }

                                            </BotonNivelActividad>


                                    )
                                )
                    }


                </ColumnaNavegacion>


                {/*
                ====================================
                NIVEL CINCO
                ====================================
                */}


                <ColumnaNavegacion>


                    <TituloColumnaActividad>

                        Ejercicios

                    </TituloColumnaActividad>


                    {
                        !cinco
                            ?
                            null
                            :
                            cinco

                                .filter(
                                    item =>
                                        item.id_cuatro ===
                                            cuatroId &&
                                        item.id_cinco !==
                                            ''
                                )

                                .map(
                                    item => (


                                        item.ultimo ===
                                        'cinco'
                                            ?

                                            <FilaEjercicio

                                                key={
                                                    item.id
                                                }

                                            >


                                                <MiniaturaEjercicio

                                                    src={
                                                        `/img/portadas/${
                                                            actividades.find(
                                                                ele =>
                                                                    item.id ===
                                                                    ele.id
                                                            ).portada
                                                        }.jpg`
                                                    }

                                                />


                                                <NombreEjercicio>

                                                    {
                                                        item.nombre_mostrar
                                                    }

                                                </NombreEjercicio>


                                                <IndicadorSeleccion

                                                    type="button"

                                                    seleccionado={
                                                        item.color
                                                    }

                                                    onClick={
                                                        (e) =>
                                                            seleccionoEjercicio(
                                                                e,
                                                                item.id,
                                                                "cinco",
                                                                item.color
                                                            )
                                                    }

                                                />


                                            </FilaEjercicio>


                                            :

                                            <BotonNivelActividad

                                                key={
                                                    item.id_cinco
                                                }

                                                type="button"

                                                activo={
                                                    cincoId ===
                                                    item.id_cinco
                                                }

                                                onClick={
                                                    () =>
                                                        setCincoId(
                                                            item.id_cinco
                                                        )
                                                }

                                            >

                                                {
                                                    item.cinco
                                                }

                                            </BotonNivelActividad>


                                    )
                                )
                    }


                    {
                        cinco &&
                        cuatroId &&
                        cinco.filter(
                            item =>
                                item.id_cuatro ===
                                    cuatroId &&
                                item.id_cinco !==
                                    ''
                        ).length ===
                            0
                            ?

                            <SinContenidoActividad>

                                No hay más niveles en esta categoría.

                            </SinContenidoActividad>

                            :

                            null
                    }


                </ColumnaNavegacion>


            </NavegadorActividades>


        </ContenedorDisponibles>

    );

};


export default SeleccionarActividadesDisponibles;